import ThankYouPage from '../forms/ThankYouPage'

const PergolaLandingThankYou = () => (
    <ThankYouPage returnPath="/landing-pergola" contentCategory="Pergola" landingMode />
)

export default PergolaLandingThankYou
